import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

export default function RankingLandingSkeleton() {
  return (
    <div className="ranking-lp">
      <section className="rk-hero">
        <div className="rk-container">
          {/* Mesma sequência do hero de verdade: título, barra de busca (uma pílula alta
              de ponta a ponta), fileira de atalhos e a linha de dois banners. */}
          <div className="rk-hero-copy">
            <Skeleton height={52} width="70%" />
            <div style={{ marginTop: 22, width: "100%" }}>
              <Skeleton borderRadius={999} height={76} />
            </div>
            <div style={{ marginTop: 22, width: "100%" }}>
              <Skeleton height={42} width="80%" />
            </div>
            <div className="rk-hero-banners" style={{ marginTop: 22 }}>
              <Skeleton borderRadius={20} height={196} />
              <Skeleton borderRadius={20} height={196} />
            </div>
          </div>
        </div>
      </section>

      <section className="rk-quick">
        <div className="rk-container">
          <Skeleton height={44} width={240} />
          <ul className="rk-quick-grid" style={{ marginTop: 28 }}>
            {Array.from({ length: 8 }).map((_item, i) => (
              <li key={i}>
                <Skeleton height={168} />
              </li>
            ))}
          </ul>
        </div>
      </section>
    </div>
  );
}
